import React, { Component } from 'react';
import { Grid, Dropdown, Form, Segment, Header } from 'semantic-ui-react';
import { getActuaryReport } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import MessageBox from '../../ui/MessageBox';
import Loading from '../Loading';
class ActuaryReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchIndex: {
                cltClientIds: "",
                pdf: false
            },
            msg11open: false,
            loading: false

        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "reports_actuary.md");
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    handleChange = (e, data) => {
        this.setState({
            searchIndex: {
                ...this.state.searchIndex,
                [data.name]: data.value
            }
        });

    }

    handleSubmit = (e, pdf) => {
        e.preventDefault();

        if (this.state.searchIndex.cltClientIds > 0) {
            this.setState({
                loading: true,
                searchIndex: {
                    ...this.state.searchIndex,
                    pdf: pdf
                }
            }, () => {
                getActuaryReport(this.props.items.currentCorporate, this.state.searchIndex).then((response) => {
                    if (response !== null) {
                        let disposition = response.request.getResponseHeader('Content-Disposition');
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            let matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                let filename = matches[1].replace(/['"]/g, '');
                                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                                    // IE workaround for "HTML7007: One or more blob URLs were 
                                    // revoked by closing the blob for which they were created. 
                                    // These URLs will no longer resolve as the data backing 
                                    // the URL has been freed."
                                    window.navigator.msSaveBlob(new Blob([response.data]), filename);
                                } else {
                                    const url = window.URL.createObjectURL(new Blob([response.data]));
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.setAttribute('download', filename);
                                    document.body.appendChild(link);
                                    link.click();
                                }
                            }
                        }
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    });
                })
            });
        } else {
            this.setState({
                msg11open: true
            });
        }
    }

    render() {
        return (
            <div>
                {this.state.loading ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} parent="Reports" child={[{ name: "Actuary", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Segment.Group raised>
                                <Segment inverted className="grey">
                                    <Header as="h4">Actuary Report</Header>
                                </Segment>
                                <Segment>
                                    <Form className="small">
                                        <Form.Group>
                                            <Form.Field width={6} className="required">
                                                <label>Select Client ID:</label>
                                                <Dropdown placeholder='Select Client ID' className="fluid" /*multiple*/ search selection options={this.props.items.clients.map((client) => { client.disabled = !client.allowedtoviewreport; return client; })} value={this.state.searchIndex.cltClientIds} name="cltClientIds" onChange={this.handleChange}></Dropdown>
                                            </Form.Field>
                                            <Form.Field width={6} onClick={this.handleSubmit}>
                                                <Dropdown text='Export Table Data' icon='external alternate' labeled className='icon button small floated push-down'>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={(e) => { this.handleSubmit(e, true) }} > Export as pdf</Dropdown.Item>
                                                        <Dropdown.Item onClick={(e) => { this.handleSubmit(e, false) }}> Export as excel</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </Form.Field>
                                            <Form.Field width={4} />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} size="mini" box={11} open={this.state.msg11open} close={() => { this.setState({ msg11open: false }) }} required={["Client ID(s)"]} />
            </div>
        );
    }
}
export default ActuaryReport;


// WEBPACK FOOTER //
// ./src/app/ui/reports/ActuaryReport.js